export class ProductGuideConstant {
  static readonly ENROLLMENT: string = "enrollment";
  static readonly PRODUCT_GUIDE: string = "PRODUCT_GUIDE";
  static readonly APPLICANT: string = "applicant";
}
